import { observer } from 'mobx-react-lite'
import { useOutletContext } from 'react-router'
import { type ProfileOutletContext } from '@/features/iam/users/Profile/ProfileContainer'
import { ProfileHeaderContainer } from '@/features/iam/users/components/ProfileHeader/ProfileHeaderContainer'
import { useActivation } from '@/hooks/view-model-hooks'
import { useDocumentTitle } from '@/hooks/document-title'
import { useFeatures } from '@/contexts/root-store-context'
import { ProDetailsContainer } from '@/features/iam/providers/ProDetails/ProDetailsContainer'
import { General, GeneralSections } from '@/features/iam/users/Profile/General'
import { UserInfoContainer } from '@/features/iam/users/components/UserInfo/UserInfoContainer'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { SkillsContainer } from '@/features/iam/users/components/SkillsContainer'
import { RolesContainer } from '@/features/iam/users/components/RolesContainer'

export default observer(function GeneralContainer() {
  const { vm, scrollOffset } = useOutletContext<ProfileOutletContext>()
  useActivation(vm.general)
  useDocumentTitle('General')
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  return (
    <General
      corporateMode={shellInfo.corporateMode}
      header={
        <ProfileHeaderContainer
          viewTitle="General"
          vm={vm}
          scrollOffset={scrollOffset}
        />
      }
    >
      {vm.general.fetch.match({
        pending: () => <ContentLoading />,
        rejected: (err) => <ContentError error={err} />,
        resolved: () => (
          <GeneralSections
            userInfo={<UserInfoContainer vm={vm} />}
            isRefreshDesign={vm.general.isRefreshDesign}
            onDesignToggle={vm.general.toggleDesign}
            isPro={vm.isPro}
            proDetails={vm.isPro && <ProDetailsContainer vm={vm.proDetails} />}
            canViewAndEditOwnSkills={vm.canViewAndEditOwnSkills}
            onManageSkills={vm.general.skillSelection.showEditor}
            skills={<SkillsContainer vm={vm} />}
            canViewAndEditOwnRoles={vm.canViewAndEditOwnRoles}
            onManageRoles={vm.general.roleSelection.showEditor}
            roles={<RolesContainer vm={vm} />}
          />
        ),
      })}
    </General>
  )
})
